import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function userDataReducer(state = initialState.userData, action) {
    switch(action.type){
        case types.SET_USER_DATA:
            //debugger;
            //use immutable state with es6's spread operator (...) on existing state and Object.assign to make a deep copy of existing object to create a brand new state
            return Object.assign({},action.userData);

        default:
            return state;
    }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/userDataReducer.js
 **/